<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import copyrightConfig from "@/utils/config/changeCopyright.js";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      // title = typeof title === "function" ? title(this.$store) : title;

      // 如果标题已经包含品牌信息（如登录页面），则不再重复添加
      // if (title && (title.includes("接龙加加") || title.includes("报名管家"))) {
      //   return title;
      // }

      const appid = copyrightConfig.AppID;
      const appName = appConfig.appNames[appid] || "接龙加加";

      return title
        ? `${title} - ${appName}`
        : `${appName} - 免费微信接龙报名小程序平台`;
      // return title
      //   ? `${title} | ${appName} - 免费微信接龙报名小程序平台`
      //   : `${appName} - 免费微信接龙报名小程序平台`;
    },
  },
};
</script>
<style lang="scss">
  .el-tooltip__popper {
    max-width: 1000px !important;
  }
</style>
